<template>
  <figure class="wiki-image" @dblclick="open">
    <img :src="props.src" :alt="alt || ''" loading="lazy" />
    <figcaption><slot></slot></figcaption>
    <dialog ref="dialog" class="fullscreen" @click="close">
      <figure>
        <img :src="props.src" :alt="alt || ''" loading="lazy" />
        <figcaption><slot></slot></figcaption>
      </figure>
    </dialog>
  </figure>
</template>

<script setup lang="ts">
const props = defineProps<{
  src: string
  alt?: string
}>()

const dialog = ref<HTMLDialogElement | null>(null)

const open = () => {
  dialog.value?.showModal()
}

const close = () => {
  dialog.value?.close()
}
</script>

<style lang="postcss">
.wiki-image {
  padding: 0;
  overflow: hidden;
  margin: 1.5em auto;
  display: flex;
  flex-direction: column;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 66svh;
    margin: 0 auto;
    object-fit: contain;
  }

  figcaption {
    text-align: center;
    padding: 0.25rem 0.5rem 0;
    font-size: 0.9em;
    font-weight: 500;

    p:last-child {
      margin-block-end: 0;
    }

    &:empty {
      padding: 0;
    }
  }

  @media (min-width: 601px) {
    &.floatright {
      margin: 0 0 1.5rem 1rem;
    }
  }

  &.lineart {
    :is(.darkmode) & img {
      filter: invert(100%);
    }

    figcaption {
      font-size: 0.8em;
      font-family: var(--font-stack-title);
    }
  }

  @container factbox (width) {
    &:first-child {
      margin-top: -0.5em !important;
    }
    margin: 0.5em 0;
  }

  @container hero (width) {
    margin: 0 auto 1rem;

    img {
      max-height: 50vh;
      object-fit: contain;
    }

    &.panorama {
      margin: 0 0 1rem;
      width: 100%;

      img {
        object-fit: cover;
        object-position: center;
        width: 100%;
        margin: 0;
        max-height: 66svh;
      }
    }
  }

  @container pano (width) {
    margin: 0;

    img {
      max-height: 66svh;
      object-fit: contain;
    }

    &.panorama {
      width: 100%;

      img {
        object-fit: cover;
        object-position: center;
        width: 100%;
        margin: 0;
        max-height: 50svh;
      }
    }
  }

  .fullscreen {
    z-index: 2000;
    background-color: var(--background);
    border: none;
    width: 100lvw;
    height: 100lvh;
    padding: 1em;

    &:open {
      display: fixed;
      inset: 0;
    }

    &::backdrop {
      background-color: var(--background);
    }

    figure {
      display: flex;
      flex-direction: column;
      margin: 0;
      padding: 0;
      height: 100%;
      width: 100%;

      img {
        object-fit: contain;
        flex: 1;
        height: 100%;
        width: 100%;
        max-height: none;
        max-width: none;
      }

      .caption {
        color: var(--text);
        text-align: center;
        padding: 0.25rem 0.5rem 0;
        font-size: 0.9em;
        font-weight: 500;

        p:last-child {
          margin-block-end: 0;
        }

        &:empty {
          padding: 0;
        }
      }
    }
  }
}

</style>
